/* Component Dependencies */
var hwsSiteMapTemplate = require('templates/hwsSiteMap.hbs');
var hwsSiteMapFooterTemplate = require('templates/hwsSiteMap-footer.hbs');

var AriesComponent = require('libs/aries-component');

AriesComponent.create({
	type: 'hwsSiteMap',
	template: {
		'hwsSiteMap': hwsSiteMapTemplate,
		'hwsSiteMap-footer': hwsSiteMapFooterTemplate
	}
});
